/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import moment from "moment";
import "./IncidentActivityLog.scss";
import { Breadcrumb, Button, Modal, Form } from "react-bootstrap";
import { BsPerson, BsLaptop } from "react-icons/bs";
import Utils from "../../../core/utilities/Utils";
import IncidentReportService from "../../../core/service/IncidentReportService";
import SupplierService from "../../../core/service/SupplierService";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import { STATUS, INCIDENTSTATUS, IncidentPriority } from "../../../core/constants/common";
import { Typeahead } from "react-bootstrap-typeahead";

function IncidentActivityLog({ t }) {
  const authorityData = JSON.parse(localStorage.getItem("authority"));
  const { paramObj } = useParams();
  let obj = Utils.decodeBase64(paramObj);
  var decodedObj = JSON.parse(obj);
  let incidentId = decodedObj.id;
  let incidentCode = decodedObj.code;
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [assignto, setAssignto] = useState("");
  const [selStatus, setSelStatus] = useState("");
  const [activityLogs, setActivityLogs] = useState([]);
  const [show, setShow] = useState(false);
  const [comments, setComments] = useState("");
  const [validated, setValidated] = useState(false);
  const [disabled, setDisabled] = useState("");
  useEffect(() => {
    incidentId && getIncidentDetails(incidentId);
    incidentId && getIncidentActivity(incidentId);
    incidentId && getAssignto();
  }, [incidentId]);
  const getIncidentDetails = (id) => {
    IncidentReportService.getIncidentDetails(id)
      .then((response) => {
        let res = response?.data;
        setData(res);
        setSelStatus(res?.status);
        setAssignto(res?.assignee?.id);
      })
      .catch((error) => {});
  };
  const getAssignto = (key = "") => {
    CompanyDashboardService.getUsers(key)
      .then((response) => {
        setUsers([...response.data]);
      })
      .catch((error) => {});
  };
  const filterBy = () => true;
  const handleAssignee = async (val) => {
    IncidentReportService.updateAssignee(incidentId, val)
      .then((response) => {
        if (response.status === 200) {
          setAssignto(val);
          getIncidentDetails(incidentId);
          getIncidentActivity(incidentId);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {});
  };
  const handleStatus = async (val) => {
    setDisabled("disabled");
    IncidentReportService.updateIncidentStatus(incidentId, val)
      .then((response) => {
        if (response.status === 200) {
          setDisabled("");
          setSelStatus(val);
          getIncidentDetails(incidentId);
          getIncidentActivity(incidentId);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {});
  };
  const getIncidentActivity = (id) => {
    IncidentReportService.getIncidentActivityLogs(id)
      .then((response) => {
        let res = response?.data;
        setActivityLogs(res);
      })
      .catch((error) => {});
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleComment = () => {
    if (!comments) {
      setShow(true);
      setValidated(true);
    } else {
      setShow(false);
      let param = {
        note: comments,
      };

      IncidentReportService.createComment(param, incidentId)
        .then((response) => {
          if (response.status === 200) {
            setComments("");

            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            incidentId && getIncidentDetails(incidentId);
            incidentId && getIncidentActivity(incidentId);
          }
        })
        .catch((error) => {});
    }
  };
  const showComment = () => {
    setShow(true);
    setValidated(false);
  };
  return (
    <div className="IncidentActivityLog">
      <div className="IncidentActivityLog_row">
        <div className="List_header">
          <h5 className="MH">
            <Link to="/company_admin/incident_list" className="Search_iocnBox">
              {t("Incidents.label")}
              <BiChevronRight />
            </Link>
            {data?.code}
          </h5>
        </div>
        <div className="row m-0 ">
          <div className="col-md-6 p-2">
            <h6>{t("IncidentDetails.label")}</h6>
            <div className="Incident_detailsView_01">
              <table>
                <tbody>
                  <tr>
                    <th scope="row">{t("ReferenceNo.label")}.</th>
                    <td>{data?.code}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Title.label")}</th>
                    <td>{data?.title}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Description.label")}</th>
                    <td>{data?.description}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("IncidentType.label")}</th>
                    <td>{data?.incidentType?.name}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Reportedto.label")}</th>
                    <td>{data?.owner?.name}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Reportedon.label")}</th>
                    <td>{moment(data?.createdDate).format("MMM DD, YYYY")}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Priority.label")}</th>
                    <td>{Utils.getIncidentPriorityText(IncidentPriority[`${data?.priority}` || 0])}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Status.label")}</th>
                    <td>
                      {
                        data.owner?.id === authorityData.profile?.company?.id
                        ? 
                        <select
                          className="form-select"
                          value={selStatus}
                          onChange={(e) => handleStatus(e.target.value)}
                          required
                          disabled={disabled}>
                          <option value="" disabled hidden>
                            {t("Select.label")}
                          </option>
                          {INCIDENTSTATUS?.map((type) => (
                            <option value={type.key} key={type.key}>
                              {type.value}
                            </option>
                          ))}
                        </select>
                        : <>{INCIDENTSTATUS?.find(s => s.key === selStatus)?.value}</>
                      }
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Assignee.label")}</th>
                    <td>
                      {
                        data.owner?.id === authorityData.profile?.company?.id
                        ? 
                        <select
                          className="form-select"
                          value={assignto}
                          onChange={(e) => handleAssignee(e.target.value)}
                          required>
                          <option value="" disabled hidden>
                            {t("Select.label")}
                          </option>
                          {users?.map((type) => (
                            <option value={type.id} key={type.id}>
                              {type.name}
                            </option>
                          ))}
                        </select>
                        : <>{data.assignee?.fullName}</>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-6 p-2">
            <h6>{t("ReporterDetails.label")}</h6>
            <div className="Incident_detailsView_01">
              <table>
                <tbody>
                  <tr>
                    <th scope="row">{t("Name.label")}</th>
                    <td>{data?.reportedBy?.name}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Email.label")}</th>
                    <td>{data?.reportedBy?.email}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("PhoneNumber.label")}</th>
                    <td>{data?.reportedBy?.phoneNumber}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-lg-9">
          <div className="py-2 Activity-header">
            <h6>{t("ActivityLog.label")}</h6>
            <div className="List_menu">
              <Button
                variant="primary"
                onClick={(e) => showComment()}
              >
                + {t("Comment.label")}
              </Button>
            </div>
          </div>

          <div className="Activity_log_view">
            {Object.keys(activityLogs)?.map((key, index) => {
              return (
                <div className="Activity_log_view_single" key={key}>
                  <div className="Activity_log_view_single_head">
                    <h6>{key}</h6>
                  </div>
                  {activityLogs[key]?.map((item, index) => (
                    <div
                      className="Activity_log_view_single_body"
                      key={item?.id}
                    >
                      <ul>
                        <li>
                          <div className="Activity_log_timebox">
                            <div className="Activity_log_timebox_icon">
                              <BsPerson />
                            </div>
                            {moment(item?.time).format("LT")}
                          </div>
                          <div className="AL_View_inner">
                            {(() => {
                              switch (item?.type) {
                                case "STATUS_CHANGED":
                                  return (
                                    <div className="AL_View_inner_head">
                                      <h6>{STATUS[item.newStatus]}</h6>
                                      <p>
                                        {(item?.prevStatus ||
                                          item?.newStatus) &&
                                          t("Statuschanged.label")}
                                        {item?.prevStatus && t("from.label")}{" "}
                                        {STATUS[item?.prevStatus]}
                                        {item?.newStatus &&
                                          " " + t("to.label")}{" "}
                                        {STATUS[item?.newStatus]}
                                      </p>
                                    </div>
                                  );
                                case "NOTE_ADDED":
                                  return (
                                    <div className="AL_View_inner_Comment">
                                      <h6>{t("CommentAdded.label")}</h6>
                                      <div className="Comment_person01">
                                        {Utils.nameInitials(
                                          item?.actor?.fullName
                                        )}
                                      </div>
                                      <p>{item?.note?.note}</p>
                                    </div>
                                  );
                                case "ASSIGNED":
                                  return (
                                    <div className="AL_View_inner_body">
                                      <h6>
                                        {t("Assignedto.label")}{" "}
                                        {item?.assignee?.fullName}
                                      </h6>
                                    </div>
                                  );
                                case "CREATED":
                                  return (
                                    <div className="AL_View_inner_body">
                                      <h6>{t("Created.label")}</h6>
                                    </div>
                                  );
                                case "CLOSED":
                                  return (
                                    <div className="AL_View_inner_body">
                                      <h6>{t("Closed.label")}</h6>
                                    </div>
                                  );

                                case "REJECTED":
                                  return (
                                    <div className="AL_View_inner_body">
                                      <h6>{t("Rejected.label")}</h6>
                                    </div>
                                  );

                                default:
                                  return " ";
                              }
                            })()}
                          </div>
                        </li>
                      </ul>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title as="h5"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <div className="mb-4 row mx-0">
              <div className="col-lg-12">
                <strong>
                  {" "}
                  {t("Addnewcommentfortheincident.label")} {incidentCode}
                </strong>
              </div>
              <div className="col-lg-12 p-2">
                <label className="mb-1">{t("Comments.label")} *</label>
                <textarea
                  className="form-control"
                  required
                  onChange={(e) => setComments(e.target.value)}
                  defaultValue={comments}
                ></textarea>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} autoFocus>
            {t("Discard.label")}
          </Button>
          <Button variant="primary" onClick={handleComment} className="sbmBtn">
            {t("Submit.label")}
          </Button>
          {/* <Button variant="submit">{t("Submit.label")}</Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

IncidentActivityLog.propTypes = {};

IncidentActivityLog.defaultProps = {};

export default withTranslation()(IncidentActivityLog);
